import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import App from './App';

// Type definitions for <div css={...} />
// Be aware `import 'styled-components/macro' still
// needs to added to every file that uses `css` property.
// See: https://styled-components.com/docs/api#usage-with-typescript
// eslint-disable-next-line import/no-unresolved
import type {} from 'styled-components/cssprop';

// This will add cookies when requesting to backend
// and help to validation process using express session
// Otherwise admin URLs won't be validated due to lack of cookie (id_web_admin)
axios.defaults.withCredentials = true;

// Note: This hack is required because of: https://github.com/facebook/create-react-app/issues/11773
// @ts-ignore
window.process = {
    ...window.process,
};

ReactDOM.render(<App />, document.getElementById('root'));
